<template>
  <section class="banner-section">
    <div class="banner-slider">
      <div 
        class="banner-track" 
        :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
      >
        <div 
          class="banner-slide" 
          v-for="(slide, index) in slides" 
          :key="index"
          :style="{ backgroundImage: `url(${slide.image})` }"
        >
          <div class="slide-overlay"></div>
          <div class="slide-content">
            <span class="slide-subtitle" :class="{ active: currentSlide === index }">
              {{ slide.subtitle }}
            </span>
            <h2 class="slide-title" :class="{ active: currentSlide === index }">
              {{ slide.title }}
            </h2>
            <p class="slide-desc" :class="{ active: currentSlide === index }">
              {{ slide.description }}
            </p>
            <router-link 
              :to="slide.link" 
              class="slide-btn"
              :class="{ active: currentSlide === index }"
            >
              자세히 보기
              <span class="btn-arrow">→</span>
            </router-link>
          </div>
        </div>
      </div>

      <!-- 네비게이션 화살표 -->
      <button class="nav-arrow prev" @click="prevSlide">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M15 18l-6-6 6-6"/>
        </svg>
      </button>
      <button class="nav-arrow next" @click="nextSlide">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M9 18l6-6-6-6"/>
        </svg>
      </button>

      <!-- 인디케이터 -->
      <div class="banner-indicators">
        <div class="indicator-wrapper">
          <button 
            v-for="(slide, index) in slides" 
            :key="index"
            class="indicator"
            :class="{ active: currentSlide === index }"
            @click="goToSlide(index)"
          >
            <span class="indicator-progress" v-if="currentSlide === index"></span>
          </button>
        </div>
        <div class="slide-counter">
          <span class="current">{{ String(currentSlide + 1).padStart(2, '0') }}</span>
          <span class="divider">/</span>
          <span class="total">{{ String(slides.length).padStart(2, '0') }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BannerSection',
  data() {
    return {
      currentSlide: 0,
      autoplayInterval: null,
      autoplayDelay: 6000,
      slides: [
        {
          subtitle: 'PREMIUM LIVING',
          title: '새로운 라이프스타일의 시작',
          description: '최고급 프리미엄 주거 공간에서 특별한 일상을 경험하세요',
          image: require('@/assets/banner/banner1.jpg'),
          link: '/business/overview'
        },
        {
          subtitle: 'SPECIAL COMMUNITY',
          title: '품격있는 커뮤니티 시설',
          description: '입주민만을 위한 프리미엄 커뮤니티 공간을 제공합니다',
          image: require('@/assets/banner/banner2.jpg'),
          link: '/complex/community'
        },
        {
          subtitle: 'NATURE & LIFE',
          title: '자연과 함께하는 삶',
          description: '도심 속 자연을 느낄 수 있는 친환경 단지 설계',
          image: require('@/assets/banner/banner3.jpg'),
          link: '/complex/design'
        }
      ]
    }
  },
  mounted() {
    this.startAutoplay()
  },
  beforeUnmount() {
    this.stopAutoplay()
  },
  methods: {
    nextSlide() {
      this.currentSlide = (this.currentSlide + 1) % this.slides.length
      this.resetAutoplay()
    },
    prevSlide() {
      this.currentSlide = (this.currentSlide - 1 + this.slides.length) % this.slides.length
      this.resetAutoplay()
    },
    goToSlide(index) {
      this.currentSlide = index
      this.resetAutoplay()
    },
    startAutoplay() {
      this.autoplayInterval = setInterval(() => {
        this.currentSlide = (this.currentSlide + 1) % this.slides.length
      }, this.autoplayDelay)
    },
    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval)
      }
    },
    resetAutoplay() {
      this.stopAutoplay()
      this.startAutoplay()
    }
  }
}
</script>

<style scoped>
.banner-section {
  width: 100%;
  height: 100vh;
  min-height: 600px;
  position: relative;
  overflow: hidden;
  margin-top: -80px;
}

.banner-slider {
  width: 100%;
  height: 100%;
  position: relative;
}

.banner-track {
  display: flex;
  height: 100%;
  transition: transform 0.8s cubic-bezier(0.65, 0, 0.35, 1);
}

.banner-slide {
  min-width: 100%;
  height: 100%;
  position: relative;
  background-size: cover;
  background-position: center;
}

.slide-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.6) 0%,
    rgba(0, 0, 0, 0.3) 50%,
    rgba(0, 0, 0, 0.4) 100%
  );
}

.slide-content {
  position: absolute;
  top: 50%;
  left: 10%;
  transform: translateY(-50%);
  color: #fff;
  z-index: 10;
  max-width: 600px;
}

.slide-subtitle {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 4px;
  color: var(--main-color1);
  margin-bottom: 20px;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease 0.2s;
}

.slide-subtitle.active {
  opacity: 1;
  transform: translateY(0);
}

.slide-title {
  font-size: 52px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 24px;
  letter-spacing: -1px;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease 0.4s;
}

.slide-title.active {
  opacity: 1;
  transform: translateY(0);
}

.slide-desc {
  font-size: 18px;
  font-weight: 400;
  line-height: 1.7;
  margin-bottom: 40px;
  opacity: 0;
  transform: translateY(30px);
  transition: all 0.6s ease 0.6s;
}

.slide-desc.active {
  opacity: 0.9;
  transform: translateY(0);
}

.slide-btn {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  padding: 16px 36px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.5);
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.4s;
  opacity: 0;
  transform: translateY(30px);
}

.slide-btn.active {
  opacity: 1;
  transform: translateY(0);
  transition: all 0.6s ease 0.8s, background 0.3s, border-color 0.3s;
}

.slide-btn:hover {
  background: var(--main-color1);
  border-color: var(--main-color1);
}

.slide-btn .btn-arrow {
  transition: transform 0.3s;
}

.slide-btn:hover .btn-arrow {
  transform: translateX(5px);
}

/* 네비게이션 화살표 */
.nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  z-index: 20;
}

.nav-arrow svg {
  width: 24px;
  height: 24px;
  color: #fff;
}

.nav-arrow:hover {
  background: var(--main-color1);
  border-color: var(--main-color1);
}

.nav-arrow.prev {
  left: 40px;
}

.nav-arrow.next {
  right: 40px;
}

/* 인디케이터 */
.banner-indicators {
  position: absolute;
  bottom: 60px;
  left: 10%;
  display: flex;
  align-items: center;
  gap: 30px;
  z-index: 20;
}

.indicator-wrapper {
  display: flex;
  gap: 12px;
}

.indicator {
  width: 40px;
  height: 3px;
  background: rgba(255, 255, 255, 0.3);
  border: none;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s;
}

.indicator:hover {
  background: rgba(255, 255, 255, 0.5);
}

.indicator.active {
  width: 60px;
  background: rgba(255, 255, 255, 0.3);
}

.indicator-progress {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: var(--main-color1);
  animation: progress 6s linear forwards;
}

@keyframes progress {
  from { width: 0%; }
  to { width: 100%; }
}

.slide-counter {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #fff;
  font-weight: 500;
}

.slide-counter .current {
  font-size: 20px;
  font-weight: 600;
  color: var(--main-color1);
}

.slide-counter .divider {
  opacity: 0.5;
}

.slide-counter .total {
  opacity: 0.7;
}

/* 스크롤 인디케이터 */
.scroll-indicator {
  position: absolute;
  bottom: 60px;
  right: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  z-index: 20;
}

.scroll-text {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.7);
  writing-mode: vertical-rl;
}

.scroll-line {
  width: 1px;
  height: 60px;
  background: rgba(255, 255, 255, 0.3);
  position: relative;
  overflow: hidden;
}

.scroll-dot {
  width: 100%;
  height: 20px;
  background: var(--main-color1);
  animation: scrollDown 1.5s ease-in-out infinite;
}

@keyframes scrollDown {
  0% { transform: translateY(-100%); }
  50% { transform: translateY(100%); }
  100% { transform: translateY(300%); }
}

/* 반응형 */
@media (max-width: 1024px) {
  .banner-section {
    margin-top: -65px;
  }

  .slide-content {
    left: 5%;
    right: 5%;
    max-width: none;
  }

  .slide-title {
    font-size: 38px;
  }

  .slide-desc {
    font-size: 16px;
  }

  .nav-arrow {
    width: 50px;
    height: 50px;
  }

  .nav-arrow.prev { left: 20px; }
  .nav-arrow.next { right: 20px; }

  .banner-indicators {
    left: 5%;
    bottom: 40px;
  }

  .scroll-indicator {
    display: none;
  }
}

@media (max-width: 768px) {
  .slide-subtitle {
    font-size: 12px;
    letter-spacing: 3px;
  }

  .slide-title {
    font-size: 28px;
    margin-bottom: 16px;
  }

  .slide-desc {
    font-size: 14px;
    margin-bottom: 30px;
  }

  .slide-btn {
    padding: 14px 28px;
    font-size: 14px;
  }

  .nav-arrow {
    display: none;
  }

  .indicator {
    width: 24px;
  }

  .indicator.active {
    width: 36px;
  }

  .slide-counter {
    display: none;
  }
}
</style>